import { Flex, type FlexProps } from "@chakra-ui/react";

export function ScreenWrapper({
  children,
  flexProps,
}: {
  children: React.ReactNode;
  flexProps?: FlexProps;
}) {
  return (
    <Flex
      direction={"column"}
      p={{ base: 4, md: 0 }}
      pt={{ base: 4, md: 2 }}
      gap={8}
      {...flexProps}
    >
      {children}
    </Flex>
  );
}
